<template>
    <div style="background-color: #fff">
        <div class="top-title">消息列表</div>
        <!--        <div class="type-list">-->
        <!--            <div class="item" @click="typeChange(1)" :class="{active:type===1}">系统消息-->
        <!--                <span class="tip"></span>-->
        <!--            </div>-->
        <!--            <div class="item" @click="typeChange(2)" :class="{active:type!==1}">通知-->
        <!--                <span class="tip"></span>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="operation">
            <div class="left-part">
                <div class="item">
                    <el-button type="primary" @click="setRead" :disabled="selected.length===0" size="mini">标为已读
                    </el-button>
                </div>
                <div class="item">
                    <el-button type="warning" @click="deleteMessage" :disabled="selected.length===0" size="mini">删除
                    </el-button>
                </div>
            </div>
            <div class="right-part">
                <div class="item">
                    <el-select @change="typeChange" v-model="second_type" size="mini" placeholder="消息类型">
                        <el-option
                            v-for="item in second_types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="">
            <el-table
                border
                stripe
                :data="tableData"
                @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="消息标题"
                >
                    <template slot-scope="scope">
                        <message-type :detail="scope.row"></message-type>
                    </template>
                </el-table-column>
                <el-table-column
                    label="消息详情">
                    <template slot-scope="scope">
                        <message-detail :detail="scope.row"></message-detail>
                    </template>
                </el-table-column>
                <el-table-column
                    label="消息时间"
                    width="180">
                    <template slot-scope="scope">
                        <format-time :time="scope.row.create_time"></format-time>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="80">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="previewMessage(scope.row)">预览
                        </el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pb-3 mt-3">
            <el-pagination
                @size-change="sizeChange"
                @current-change="pageChange"
                :current-page="page.pageNumber"
                :page-sizes="[10, 15, 30, 50]"
                :page-size="page.pageSize"
                :background="true"
                layout="sizes,prev, pager,next,total"
                :total="page.total">
            </el-pagination>
        </div>
        <el-dialog
            title="消息详情"
            :visible.sync="detail.show"
            width="920px"
            :before-close="()=>{detail.show=false}">
            <div>
                <iframe :src="detail.url" style="width: 900px;height: 600px;" frameborder="0"></iframe>
            </div>
            <div slot="footer" class="dialog-footer">
    <el-button type="primary" @click="detail.show = false">确 定</el-button>
  </div>
        </el-dialog>
        <form-dialog @closeFormDialog="submit" :title="form.title" :show="form.show" :fields="form.fields"
                     :rules="form.rules" :data="form.data"></form-dialog>
    </div>
</template>
<script>
import FormatTime from "@/components/common/format-time.vue";
import F from '@/fields/fields';
import MessageType from "@/components/user/profile/message-type.vue";
import MessageDetail from "@/components/user/profile/message-detail.vue";

export default {
    components: {
        FormatTime, MessageType, MessageDetail
    },
    created() {

    },
    mounted() {
        this.search();
    },
    data: function () {
        return {
            baseUrl: '/bbs/message/index',
            tableData: [],
            type: 1,
            detail: {
                show: false,
                url:'',
            },
            selected: [],
            second_type: '',
            page: {
                search: {},
                sort: {},
                total: 1,
                pageSize: 10,
                pageNumber: 1,
            },
            form: {
                action_name: '',
                show: false,
                title: '',
                data: {},
                fields: [],
                rules: {},
            }
        }
    },
    computed: {
        second_types: function () {
            let arr = this.$store.state.dict.message_types.filter(v => {
                // v.for === this.type;
                return 1;
            });
            arr.unshift({label: '请选择', value: ''});
            return arr;
        },
        searchFields: function () {
            return F.search('invoiceTitle', 'search');
        },
        showFields: function () {
            return F.show('invoiceTitle', 'show');
        },
    },
    methods: {
        handleSelectionChange(v) {
            this.selected = v.map(v => v.id);
        },
        typeChange(v) {
            this.page.pageNumber = 1;
            // this.second_type=v;
            this.search();
            // this.type = v;
            // this.second_type = '';
        },
        condition: function (search) {
            this.page.search = search;
            this.page.pageNumber = 1;
            this.search();
        },
        search: function () {
            this.selected.splice(0, 100000);
            let search_params = JSON.parse(JSON.stringify(this.page));
            if (this.second_type) {
                search_params.search.second_type = this.second_type;
            }
            this.$bbs.get(this.baseUrl, {
                params: search_params,
            }).then(data => {
                this.tableData = data.data.data;
                this.page.total = data.data.total;
                this.page.pageNumber = data.data.pageNumber;
                this.page.pageSize = data.data.pageSize;
            });
        },
        previewMessage(detail) {
            if (detail.message && detail.message.data && detail.message.data.url) {
                this.detail.url= detail.message.data.url;
                this.detail.show=true;
            }
        },
        sortChange: function (column) {
            if (!column.order) return;
            this.page.sort = {prop: column.prop, order: column.order};
            this.search();
        },
        sizeChange: function (size) {
            this.page.pageSize = size;
            this.search();
        },
        pageChange: function (page) {
            this.page.pageNumber = page;
            this.search();
        },
        filterPlatform(value, row) {
            return row.tag === value;
        },
        submit: function (data) {
            // this.con(data);
            if (data.type === 'cancel') {
                this.form.show = false;
                return;
            }
            switch (this.actionName) {
                case 'editPiao':
                    this.$bbs.put(this.baseUrl, data.data).then(adData => {
                        this.$message.success('保存成功!');
                        this.tableData.splice(this.index, 1, adData.data);
                        this.form.show = false;
                    });
                    break;
                case 'addPiao':
                    this.$bbs.post(this.baseUrl, data.data).then(userData => {
                        this.page.total++;
                        this.$message.success('添加成功!');
                        this.form.show = false;
                        this.tableData.unshift(userData.data);
                    });
                    break;
            }
        },
        editPiao: function (index) {
            let form;
            let data = this.tableData[index];
            if (data.type === 'pu') {
                form = F.get('invoiceTitle', 'edit_pu', data);
            } else {
                form = F.get('invoiceTitle', 'edit_zhuan', data);
            }
            this.actionName = 'editPiao';
            this.form = form;
            this.index = index;
        },
        addPiao: function (type) {
            let form;
            if (type === 'zhuan') {
                form = F.get('invoiceTitle', 'add_zhuan', {type: 'zhuan'});
            } else {
                form = F.get('invoiceTitle', 'add_pu', {type: 'pu'});
            }
            this.actionName = 'addPiao';
            this.form = form;
        },
        deleteMessage() {
            this.$confirm('你真的要删除所选的消息吗吗?', '操作确认').then(() => {
                this.$bbs.delete(this.baseUrl, {data: {ids: this.selected}}).then(() => {
                    this.search();
                    this.$message.success('删除成功!');
                });
            });
        },
        setRead() {
            this.$bbs.put(this.baseUrl, {ids: this.selected, method: 'read'}).then(() => {
                this.tableData.map(v => {
                    if (this.selected.indexOf(v.id) > -1) {
                        v.status = 1;
                    }
                });
                this.$message.success('操作成功!');
            });
        },
    }
}

</script>

<style lang="less" scoped>
.top-title {
    font-size: 16px;
    padding: 20px 0;
    //padding-top: 25px;
    color: #333;
}

.type-list {
    display: flex;
    padding: 30px 0;

    .item {
        padding-right: 40px;
        position: relative;
        cursor: pointer;

        &.active {
            color: #1a92f1;
            font-weight: bold;
            //font-weight: 500;
        }

        .tip {
            position: absolute;
            right: 30px;
            top: -2px;
            width: 6px;
            height: 6px;
            background: red;
            border-radius: 50px;
        }
    }
}

.operation {
    display: flex;
    padding-bottom: 15px;

    .left-part {
        flex: 1;
        display: flex;

        .item {
            padding-right: 20px;
        }
    }

    .right-part {
        width: 200px;
        flex-shrink: 0;
    }
}

.quan-group {
    display: flex;
    padding-top: 15px;

    .quan-type {
        padding: 6px 20px;
        cursor: pointer;
        border: 1px solid transparent;
        border-radius: 50px;

        &.active {
            border: 1px solid #3f9de9;
            font-weight: 500;

            .tip {
                color: #3f9de9;
            }
        }

        .tip {
            color: #777;
        }
    }
}

.quan-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .quan-item {
        margin-bottom: 15px;
        margin-right: 20px;
    }
}

.rank {
    display: inline-block;
    margin-right: 10px;
}
</style>
